import { render, staticRenderFns } from "./AddSegmentTags.vue?vue&type=template&id=68a0e6b0&"
import script from "./AddSegmentTags.vue?vue&type=script&lang=js&"
export * from "./AddSegmentTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports